<template>
  <div id="main-wrapper" style="background-color: #25184E">
    <div class="main-content  is-footer">
      <!--اسلایدر اصلی-->
      <div style="margin-top:3px;overflow:auto"></div>


      <!--پرفروشترین ها--->
      <v-container >
        <v-card class="announcement-card">
          <v-row>
            <v-col>
              <p class="text-center font-medium font-weight-bold pt-3 white--text">
                <v-icon color="white" size="27">mdi-seal</v-icon>
                صفحه خرید سکه بازی

              </p>
            </v-col>
          </v-row>
        </v-card>

        <v-spacer style="margin-bottom: 10px"></v-spacer>
        <vcl-Twitch  v-if="!pageloading" ></vcl-Twitch>
        <vcl-Twitch  v-if="!pageloading" ></vcl-Twitch>

        <v-card v-else
                class=" mx-auto"
                style="border-radius: 16px; margin-top: 10px ;border: 2px #ffcf33 solid;"
        >

          <div class="wallet-container">
            <div class="qrcode-container">
              <qrcode-vue :value="wallet" size="300" level="H" style="padding: 10px"></qrcode-vue>
            </div>

          </div>



          <v-card-actions style="background-color: #4c4a42" >
            <v-btn
                @click="show = !show"
                color="orange lighten-2"
                text
            >
              <div style="color: #ffffff;">
              آدرس کیف پول ما
              </div>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                icon
                @click="show = !show"
            >
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>

          <v-expand-transition>
            <div v-show="show">
              <v-divider></v-divider>

              <v-card-text v-if="wallet" style="text-align: justify;background-color: #f6e06e;font-size:20px;color: #000000">
                <div class="wallet-address">
                  <span @click="copyToClipboard" style="color: #000000" class="copy-address">{{ wallet }}</span><br>
                  <v-icon @click="copyToClipboard" color="#000000">fas fa-copy</v-icon>


                </div>
              </v-card-text>

              <v-card-text style="text-align: justify;">
                در قسمت بالا آدرس کیف پول ما در شبکه پالیگان نمایش داده شده است که با کلیک بر روی آن در حافظه کپی میشود و از هر صرافی که مایل هستید میتوانید مقداری که میخواهید رمزارز Matic یا POL به این آدرس وارد کنید و کاربری شما به همان میزان به صورت سکه داخل بازی شارژ میشود. برای مثال بعد از انتقال موفقیت آمیز از سمت شما بر روی کلید زیر کلیک کنید تا عملیات تایید توسط ما انجام شود. فقط زمانی  بر روی کلید زیر کلیک نمایید که حداقل ۵ دقیقه از زمان تایید تراکنش شما گذشته باشد در غیر اینصورت برای بار دوم کاربری شما غیرفعال میشود.
                <br>
                <p>
                  قیمت هر POL ارسالی توسط شما به آدرس ذکر شده در بالا در حال حاضر
                  <span style="color: red; font-weight: bold;">
                   {{ parseFloat(usdmaticprice).toFixed(1) }}
                   </span>
                  تومان میباشد یعنی به ازای هر POL منتقل شده شما
                  <span style="color: red; font-weight: bold;">
                   {{ parseFloat(usdmaticprice).toFixed(0) }}
                  </span>
                   سکه دریافت میکنید. و اگر به همین کیف پول تتر در شبکه بایننس منتقل کنید به ازای انتقال هر تتر در شبکه بایننس مبلغ
                  <span style="color: red; font-weight: bold;">
                   {{ parseFloat(tetherprice).toFixed(0) }}
                  </span>
                  سکه به دارایی شما منتقل میشود توجه فرمایید که حتما برای انتقال تتر شبکه مقصد بایننس باشد و برای انتقال POL شبکه مقصد پالیگان باشد در غیر اینصورت ما هیچ نوع همکاری در این زمینه نخواهیم داشت.

                </p>
                <br>
                <span style="color: red; font-weight: bold;">
                  توجه:
                     </span>
                  برای هر کاربر یک کیف پول واریز قرار داده شده است بنابراین به هر آدرسی که در اینجا ذکر شده واریز کنید در غیر اینصورت سکه ای دریافت نمیکنید
              </v-card-text>
            </div>
          </v-expand-transition>
          <v-btn class="flex" @click="checkmatic" :loading="loading" depressed color="#fcba03" height="30" style="border-radius: 16px;width: 100%"> <b>  تایید انتقال POL </b></v-btn><br><hr><br><v-divider></v-divider>
          <v-btn class="flex" @click="checktether" :loading="loading" depressed color="#0fbb3d" height="30" style="border-radius: 16px;width: 100%"> <b>  تایید انتقال  تتر در شبکه بایننس </b></v-btn>
        </v-card><br>
        <v-divider></v-divider>
        <v-divider></v-divider>
      </v-container>


    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src

import {mapGetters, mapMutations} from 'vuex'
import appHeader from '../views/_header'
import appFooter from '../views/_footer'
import axios from "axios";
import { VclFacebook, VclCode,VclTwitch,VclTable } from 'vue-content-loading';
import QrcodeVue from 'qrcode.vue'  //npm i qrcode.vue@1.7.0

export default {
  name: 'Home',
  components: {
    appHeader,
    appFooter,
    VclFacebook,
    VclCode,
    VclTable,
    VclTwitch,
    QrcodeVue,

  },
  data () {
    return {
      show: true,
      wallet:"",
      tok:"",
      loading:false,
      url:'https://sharjtosharj.com/horsegame/',
      baseUrlseke:'https://fpn-afrang.com',
      usdmaticprice:0,
      tetherprice:0,
      page:1,
      pageloading: false,
      sekeimge:'https://sharjtosharj.com/horsegame/jem/seke10000.png'
    }
  },
  mounted() {
    let self = this;
    const seke = this.$route.query.id;
    if(seke=="10000")
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke10000.png';
    else if(seke=="20000")
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke20000.png';
    else if(seke=="50000")
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke50000.png';
    else if(seke=="100000")
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke100000.png';
    else if(seke=="500000")
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke500000.png';
    else
      self.sekeimge='https://sharjtosharj.com/horsegame/jem/seke500000.png';

    self.getWallet();




  },
  computed:{
    ...mapGetters(['baseUrl']),
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    ...mapMutations(["setToken","auth"]),
    generateQRCode() {


    },
    getWallet(){
      let self = this;

      var tokenbot=self.$store.getters.auth.data.tokenbot;
      if(!tokenbot>0)
        tokenbot=0;

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let formData = new FormData()
      formData.append("token", tokenbot);
     // formData.append("userid", self.$store.getters.auth.data.user_id);

      axios.post(self.baseUrlseke+'/getwallet', formData, config)
          .then(function (response) {
            if(response.data.data.result){
              self.pageloading=true;
              self.wallet = response.data.data.wallet;

              //console.log(self.wallet);

              self.generateQRCode();
              self.getMaticprice();

            }else{
              self.helperToast({
                text:response.data.message,
                color:'red',
                show:true,
              })
            }
          })
          .catch(function (error) {
            self.output = error;
          });


    },
    getMaticprice(){
      let self = this;
      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }
      var tokenbot=self.$store.getters.auth.data.tokenbot;
      if(!tokenbot>0)
        tokenbot=0;

      let formData = new FormData()
      formData.append("token", tokenbot);
      formData.append("address", self.wallet);

      axios.post(self.baseUrlseke+'/checkmatic', formData, config)
          .then(function (response) {
            if(response.data.data.result){
              self.pageloading=true;
              self.usdmaticprice = response.data.data.matic;
              self.tetherprice = response.data.data.tether;
              self.generateQRCode();

            }else{
              self.helperToast({
                text:response.data.message,
                color:'red',
                show:true,
              })
            }
          })
          .catch(function (error) {
            self.output = error;
          });


    },
    handleScroll (event) {
     /* let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.getWallet();
      }*/
    },
    checkmatic(){
      let self = this;
      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }
      self.loading = true;

      var tokenbot=self.$store.getters.auth.data.tokenbot;
      if(!tokenbot>0)
        tokenbot=0;

      let formData = new FormData()
      formData.append("token", tokenbot);
      formData.append("address", self.wallet);

      axios.post(self.baseUrlseke+'/sendmaticok', formData, config)
          .then(function (response) {
            //console.log(response.data.data.result);
            if(response.data.data.result=="1"){
              self.pageloading=true;
              self.loading = false;
              self.helperToast({
                text:response.data.data.message,
                color:'green',
                show:true,
              })


            }else{
              self.helperToast({
                text:response.data.data.message,
                color:'red',
                timeout:30000,
                show:true,
              })
              self.pageloading=true;
              self.loading = false;
            }
          })
          .catch(function (error) {
            self.output = error;
          });
    }
  ,
  checktether(){
    let self = this;
    const config = {
      headers: {'content-type': 'multipart/form-data'}
    }
    self.loading = true;

    var tokenbot=self.$store.getters.auth.data.tokenbot;
    if(!tokenbot>0)
      tokenbot=0;

    let formData = new FormData()
    formData.append("token", tokenbot);
    formData.append("address", self.wallet);

    axios.post(self.baseUrlseke+'/sendtetherok', formData, config) //inja
        .then(function (response) {
          //console.log(response.data.data.result);
          if(response.data.data.result=="1"){
            self.pageloading=true;
            self.loading = false;
            self.helperToast({
              text:response.data.data.message,
              color:'green',
              show:true,
            })


          }else{
            self.helperToast({
              text:response.data.data.message,
              color:'red',
              timeout:30000,
              show:true,
            })
            self.pageloading=true;
            self.loading = false;
          }
        })
        .catch(function (error) {
          self.output = error;
        });
  },

    copyToClipboard() {
      navigator.clipboard.writeText(this.wallet)
          .then(() => {
            this.helperToast({
              text:" آدرس با موفقیت کپی شده است",
              color:'green',
              show:true,
            })
          })
          .catch(err => {
            this.helperToast({
              text:"خطا در کپی آدرس",
              color:'red',
              show:true,
            })
          });
    }

  },
  watch:{}
}
</script>

<style>
.border-grid .col{
  height: 100px;
  border-bottom: solid 1px #e3e3e3;
  border-left: solid 1px #e3e3e3;
}
.border-grid .col:nth-child(3n + 0){
  border-left: none;
}
.border-grid .col:nth-last-child(-n + 3){
  border-bottom: none;
}
.border-grid .col p{
  font-weight: 600;
}

.border-grid2 .col{
  height: 300px;
  border-bottom: solid 1px #e3e3e3;
  border-left: solid 1px #e3e3e3;
}
.border-grid2 .col:nth-child(2n + 0){
  border-left: none;
}
.border-grid2 .col:nth-last-child(-n + 2){
  border-bottom: none;
}
.border-grid2 .col p{
  font-weight: 600;
}

.announcement-card {
  background: linear-gradient(45deg, #3498db, #8e44ad);
  border-radius: 8px 8px 0 0;
  padding: 1px 0;
}

.wallet-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qrcode-container {
  margin-bottom: 10px;
}

.wallet-address {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  cursor: pointer;
  text-align: center;
}

.copy-address:hover {
  color: #ffffff;
}

.v-icon {
  cursor: pointer;
  margin-top: 1px;
}
</style>
